/*eslint-disable*/
import axios from 'axios'

const gatewayRequestAxios = axios.create({
  timeout: 30000,
})

const setupInterceptors = () => {
  gatewayRequestAxios.interceptors.request.use(
    (config) => {
      const authToken = JSON.parse(
        localStorage.getItem('okta-token-storage')
      )
      //console.log(config.url);
      if (config.url.includes('userinfo') || config.url.includes('users') || config.url.includes('groups') || config.url.includes('audits') || config.url.includes('apps') || config.url.includes('campaigns') || config.url.includes('data') || config.url.includes('bulk-upload') || config.url.includes('reporting')) {
        if (authToken) {
          config.headers.Authorization = `Bearer ${authToken.accessToken.accessToken}`
        }
      } else {
        // const API_KEY = process.env.REACT_APP_API_KEY
        // config.headers.Authorization = `SSWS ${API_KEY}`
      }
      if (config.url.includes('igaupload')) {
        config.headers.userid = authToken.idToken.claims.email
        config.headers.email = authToken.idToken.claims.email
        delete config.headers.Accept
        delete config.headers['Content-Type']

        config.headers['Access-Control-Allow-Methods'] = ['POST,OPTIONS']
        config.headers['Content-Type'] = ['multipart/form-data']
        config.headers['Access-Control-Allow-Origin'] = ['*']
        config.headers.targetapp = ['iga_admin']
        config.headers.template = ['flatfile']
      }
      const selectedTenant = localStorage.getItem('tenant');
      if(selectedTenant !== 'J&J') {
      config.headers.tenant = selectedTenant
      }

      if (config.url.includes('bulk-upload')) {
        config.headers.userid = authToken.idToken.claims.email
        config.headers.email = authToken.idToken.claims.email
        delete config.headers.Accept
        delete config.headers['Content-Type']

        config.headers['Access-Control-Allow-Methods'] = ['POST']
        config.headers['Content-Type'] = ['multipart/form-data']
        config.headers['Access-Control-Allow-Origin'] = ['*']
        //config.headers.targetapp = ['iga_admin']
        //config.headers.template = ['flatfile']
      }


      return config
    },
    (error) => Promise.reject(error)
  )

  gatewayRequestAxios.interceptors.response.use(
    (response) => response,
    (error) => {
      const errorMessage = error.response.data?.errors?.[0]?.errors?.[0] ?
      error.response.data?.errors?.[0]?.errors?.[0] : error?.response?.data?.errors?.[0]
      
      if (errorMessage && (typeof errorMessage === 'string' || errorMessage instanceof String)) {
        throw new Error(errorMessage)
      }
      const errorMsg = error?.response?.data?.error ? error.response?.data?.error?.[0] : null;
      if (errorMsg && (typeof errorMsg === 'string' || errorMsg instanceof String)) {
        throw new Error(errorMsg)
      }
      const causeMsg = error?.response?.data?.errors?.[0]?.errorCauses;
      if (causeMsg && (typeof causeMsg === 'string' || causeMsg instanceof String)) {
        throw new Error(causeMsg)
      }
      const errorObj = error.response?.data?.errors?.[0]?.errors?.[0]?.errorCauses;
      if (errorObj) {
        throw new Error(errorObj || error.response?.data?.status)
      }
      const errorStatus = error.response?.data?.status;
      if (errorStatus) {
        throw new Error(errorStatus)
      }
      throw new Error(error);
    }
  )
}

export { gatewayRequestAxios, setupInterceptors }
